import { render } from "./AppDepositReview.vue?vue&type=template&id=603b14ef&scoped=true"
import script from "./AppDepositReview.vue?vue&type=script&lang=js"
export * from "./AppDepositReview.vue?vue&type=script&lang=js"

import "@/Common/Styles/depositReviewModal.scss?vue&type=style&index=0&id=603b14ef&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-603b14ef"]])

export default __exports__